import { Directive } from '@angular/core';
/* eslint-disable */

/**
 * Scrollable content container of a dialog.
 */
@Directive({
    selector: 'ihd-dialog-body',
    host: {
        class: 'c-dialog__body',
    },
})
export class DialogBodyComponent {}
